import { createClient } from '@supabase/supabase-js';

// Récupération et validation des variables d'environnement
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

// Validation des variables d'environnement
if (!supabaseUrl) {
  throw new Error('REACT_APP_SUPABASE_URL is not defined in environment variables');
}

if (!supabaseAnonKey) {
  throw new Error('REACT_APP_SUPABASE_ANON_KEY is not defined in environment variables');
}

// Vérification du format de l'URL
try {
  new URL(supabaseUrl);
} catch (error) {
  console.error('Invalid Supabase URL:', supabaseUrl);
  throw new Error('Invalid REACT_APP_SUPABASE_URL format');
}

// Création du client Supabase avec options de persistance de session
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'immo-prospect-auth',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

// Fonction utilitaire pour tester la connexion
export const testConnection = async () => {
  try {
    const { data: _data, error } = await supabase
      .from('categories')
      .select('count')
      .single();
    
    if (error) {
      console.error('Supabase connection error:', error);
      throw error;
    }
    
    console.log('✅ Connexion Supabase réussie');
    return true;
  } catch (error) {
    console.error('❌ Erreur de connexion Supabase:', error);
    return false;
  }
};

